import React from 'react';
import { Link } from 'react-router-dom';

import { company, addressLines, mapsUrl, mapsEmbedUrl } from '../../data/company';
import ContactForm from '../partials/ContactForm';

// Iletisim sayfasi (/contact). Sirket bilgileri src/data/company.js'ten geliyor,
// form ana sayfadakiyle ayni bilesen.
const Contact = () => (
    <main className="contact-page">

        <section className="contact-hero">
            <div className="container">

                <nav aria-label="breadcrumb" className="contact-breadcrumb mb-4">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Contact</li>
                    </ol>
                </nav>

                <h1 className="contact-hero-title">
                    Let's <span className="glowork-pink-color">talk</span>
                </h1>
                <p className="contact-hero-text mb-0">
                    Tell us where your brand is heading. We'll tell you how we can help you
                    get there, with strategic clarity and senior leadership.
                </p>

            </div>
        </section>

        <section className="contact-body">
            <div className="container">
                <div className="row g-5">

                    <div className="col-12 col-lg-5">
                        <ul className="contact-info-list list-unstyled mb-0">

                            <li className="contact-info-item">
                                <i className="bi bi-building contact-info-icon" aria-hidden="true"></i>
                                <div>
                                    <p className="contact-info-label">Company</p>
                                    <p className="contact-info-value mb-0">{company.legalName}</p>
                                </div>
                            </li>

                            <li className="contact-info-item">
                                <i className="bi bi-geo-alt contact-info-icon" aria-hidden="true"></i>
                                <div>
                                    <p className="contact-info-label">Office</p>
                                    <address className="contact-info-value mb-2">
                                        {addressLines.map((line, index) => (
                                            <React.Fragment key={index}>
                                                {line}
                                                {index < addressLines.length - 1 && <br/>}
                                            </React.Fragment>
                                        ))}
                                    </address>
                                    <a className="contact-info-link" href={mapsUrl}
                                       target="_blank" rel="noopener noreferrer">
                                        Get directions <i className="bi bi-arrow-up-right ms-1"></i>
                                    </a>
                                </div>
                            </li>

                            <li className="contact-info-item">
                                <i className="bi bi-envelope contact-info-icon" aria-hidden="true"></i>
                                <div>
                                    <p className="contact-info-label">Email</p>
                                    <a className="contact-info-link" href={`mailto:${company.email}`}>
                                        {company.email}
                                    </a>
                                </div>
                            </li>

                        </ul>
                    </div>

                    <div className="col-12 col-lg-7">
                        <h2 className="contact-form-title">Send us a message</h2>
                        <ContactForm />
                    </div>

                </div>
            </div>
        </section>

        <section className="contact-map" aria-label="Office location">
            <iframe
                title={`${company.name} office location on Google Maps`}
                src={mapsEmbedUrl}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
        </section>

    </main>
);

export default Contact;
